import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-success',
  imports: [
    MatIconModule,
    TranslatePipe
  ],
  templateUrl: './success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './success.component.scss'
})
export class SuccessComponent {

  private readonly http = inject(HttpClient);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly matIconRegistry = inject(MatIconRegistry);
  appBaseUrl = environment.appBaseUrl;

  successImgBase64 = '';

  constructor() {
    // this.http.get(`${this.appBaseUrl}/assets/svg/success.svg`, {responseType: 'text'})
    //   .subscribe((data: string) => {
        const data = '<svg width="95" height="81" viewBox="0 0 95 81" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.7612 80.233L0.430176 48.9019L13.2309 36.1013L31.7612 54.6313L82.1993 4.19324L95.0001 16.9942L31.7612 80.2204V80.233Z" fill="currentColor"/><path d="M31.8866 75.2254L1.13232 44.471L13.6948 31.9085L31.8866 50.1003L81.3969 0.589966L93.9595 13.1525L31.8866 75.2254Z" fill="white" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        this.successImgBase64 = btoa(data);
        this.matIconRegistry.addSvgIcon('success',this.domSanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${this.successImgBase64}`));
      // });
  }

}
